import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Button } from "./Button";

type Crumb = {
  label: string;
  to?: string;
};

type Props = {
  items: Crumb[];
  onBack?: () => void;
};

export function EventBreadcrumb({ items, onBack }: Props) {
  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <nav aria-label="Breadcrumb" className="min-w-0">
        <ol className="flex flex-wrap items-center gap-1 text-sm text-zinc-500">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={`${item.label}-${index}`} className="flex items-center gap-1">
                {index > 0 && (
                  <ChevronRight className="h-3.5 w-3.5 shrink-0 text-zinc-400" />
                )}
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    className="truncate text-zinc-600 hover:text-apcap"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    className={
                      isLast
                        ? "truncate font-medium text-zinc-900 dark:text-white"
                        : "truncate"
                    }
                  >
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      {onBack ? (
        <Button type="button" variant="outline" onClick={onBack}>
          Voltar
        </Button>
      ) : null}
    </div>
  );
}
